import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import RandomizationHypothesisTestingComponent from './Component';

import { doSamplesExist } from 'store/scenes/randomizationHypothesisTesting/samples/selectors';
import { getPrimaryParameterType } from 'store/scenes/randomizationHypothesisTesting/primaryParameter/selectors';
import { isSecondaryParameterSelected } from 'store/scenes/randomizationHypothesisTesting/secondaryParameter/selectors';

const RandomizationHypothesisTestingContainer = props =>
  <RandomizationHypothesisTestingComponent
    showRightAndBottomPanes={props.samplesExist}
    primaryParameterType={props.primaryParameterType}
    secondaryParameterSelected={props.secondaryParameterSelected}
  />;

RandomizationHypothesisTestingContainer.propTypes = {
  samplesExist: PropTypes.bool.isRequired,
  secondaryParameterSelected: PropTypes.bool.isRequired,

  primaryParameterType: PropTypes.string
};

RandomizationHypothesisTestingContainer.defaultProps = {
  primaryParameterType: null
};

const mapStateToProps = state => ({
  samplesExist: doSamplesExist(state),
  primaryParameterType: getPrimaryParameterType(state),
  secondaryParameterSelected: isSecondaryParameterSelected(state)
});

export default connect(mapStateToProps)(
  RandomizationHypothesisTestingContainer
);
